<template>
  <JoszakiAutocomplete
    :value="value"
    v-bind="$attrs"
    icon="user"
    :items="filteredPeople"
    :formatter="formatPerson"
    :loading="loading"
    @search="onSearch"
    @focus="onFocus"
    @input="$emit('input', $event)"
    v-on="$listeners"
  >
    <template #empty>
      {{ $t("conductor.common.noResults") }}
    </template>
  </JoszakiAutocomplete>
</template>

<script>
import { ref } from "@nuxtjs/composition-api";
import { usePersonActions } from "~/components/_refactored/conductor/persons/usePersonActions";

export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  setup(_props, { emit }) {
    const personActions = usePersonActions();
    const formatPerson = (person) => {
      if (!person) {
        return "-";
      }
      return `${person.name} | ${person.email} | #${person.id} | ${
        person.phoneNumber?.number ?? ""
      }`;
    };

    const filteredPeople = ref([]);
    const loading = ref(false);

    const onSearch = async (search) => {
      try {
        loading.value = true;
        const resp = await personActions.getPersons({
          page: 1,
          pageSize: 20,
          search,
          orderBy: "name",
          order: "asc",
        });
        filteredPeople.value = resp.items;
      } finally {
        loading.value = false;
      }
    };

    const onFocus = (search) => {
      onSearch(search ?? "");
      emit("focus", search);
    };

    return {
      filteredPeople,
      onSearch,
      onFocus,
      formatPerson,
      loading,
    };
  },
};
</script>
